export const BackendAPIIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="28" stroke="#10B981" strokeWidth="2"/>
    <path d="M20 32H44M32 20V44" stroke="#059669" strokeWidth="2"/>
    <circle cx="32" cy="32" r="4" fill="#059669"/>
  </svg>
);
export const CloudDeploymentIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 36H44C48 36 48 28 44 28C42 20 28 20 28 28H24C20 28 20 36 24 36Z" fill="#3B82F6"/>
    <path d="M32 44V52M28 48H36" stroke="#2563EB" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="32" cy="32" r="8" fill="#93C5FD"/>
  </svg>
);
export const CustomWebAppsIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="12" width="56" height="40" rx="4" stroke="#4F46E5" strokeWidth="2"/>
    <path d="M16 24H48V40H16V24Z" fill="#A5B4FC"/>
    <path d="M28 28H36V32H28V28Z" fill="#4338CA"/>
  </svg>
);
export const PerformanceOptimizationIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="36" width="48" height="16" rx="2" stroke="#F43F5E" strokeWidth="2"/>
    <path d="M16 36L24 28L32 36L40 28L48 36" stroke="#EC4899" strokeWidth="2"/>
    <path d="M32 28V20" stroke="#BE185D" strokeWidth="2"/>
  </svg>
);
export const PerformanceScalingIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 52L52 12" stroke="#EF4444" strokeWidth="3"/>
    <path d="M32 12L44 24L36 32L48 44" stroke="#DC2626" strokeWidth="3"/>
    <circle cx="32" cy="32" r="6" fill="#F87171"/>
  </svg>
);
export const UIModernizationIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="16" width="48" height="32" rx="3" stroke="#F59E0B" strokeWidth="2"/>
    <circle cx="32" cy="32" r="8" fill="#FBBF24"/>
    <path d="M24 24H40V40H24V24Z" fill="#FCD34D"/>
  </svg>
);